import { configureStore } from '@reduxjs/toolkit'
// import counterReducer from './features/counterSlice'
import userInfoReducer from './features/userInfoSlice'

export default configureStore({
  reducer: {
    // counter: counterReducer,
    userInfo: userInfoReducer
  },
})